import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { ADMIN_STATS_API } from "../../api/apiroutes";

import { FaGoogle, FaApple, FaUsers, FaUserSlash, FaUserLock } from "react-icons/fa";
import UserStatCard from "../UserStatCard"; // renamed child component

const UserProviderStats = () => {
  const [stats, setStats] = useState({
    google: 0,
    apple: 0,
    "google+apple": 0,
    deletedUsers: 0,
    suspendedUsers: 0,
    totalUsers: 0,
  });

  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.token);

  useEffect(() => {
    if (token) fetchStats();
  }, [token]);

  const fetchStats = async () => {
    try {
      const res = await axios.get(ADMIN_STATS_API.USER_PROVIDER_STATS, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-client-type": "web",
          "Content-Type": "application/json",
        
        },
      });

      setStats(res.data.data || {
        google: 0,
        apple: 0,
        "google+apple": 0,
        deletedUsers: 0,
        suspendedUsers: 0,
        totalUsers: 0,
      });
    } catch (err) {
      console.error("Stats fetch failed", err);
      setStats({
        google: 0,
        apple: 0,
        "google+apple": 0,
        deletedUsers: 0,
        suspendedUsers: 0,
        totalUsers: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="h-24 bg-gray-100 rounded-xl animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <UserStatCard
        title="Google"
        value={stats.google}
        icon={<FaGoogle />}
        color="from-red-400 to-red-600"
      />
      <UserStatCard
        title="Apple"
        value={stats.apple}
        icon={<FaApple />}
        color="from-gray-700 to-black"
      />
      <UserStatCard
        title="Google & Apple (Both)"
        value={stats["google+apple"]}
        icon={<FaUsers />}
        color="from-purple-500 to-indigo-600"
      />
      <UserStatCard
        title="Deleted"
        value={stats.deletedUsers}
        icon={<FaUserSlash />}
        color="from-rose-400 to-rose-600"
      />
      <UserStatCard
        title="Suspended"
        value={stats.suspendedUsers}
        icon={<FaUserLock />}
        color="from-yellow-400 to-orange-500"
      />
      <UserStatCard
        title="Total Users"
        value={stats.totalUsers}
        icon={<FaUsers />}
        color="from-emerald-400 to-emerald-600"
      />
    </div>
  );
};

export default UserProviderStats;
